module.exports = __webpack_public_path__ + "static/mobBG-9e4da1499478a082b92c6abf596b82f1.png";